import { render, staticRenderFns } from "./SellerProductVariantBulkUpload.vue?vue&type=template&id=0c4af564&scoped=true"
import script from "./SellerProductVariantBulkUpload.vue?vue&type=script&lang=js"
export * from "./SellerProductVariantBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./SellerProductVariantBulkUpload.vue?vue&type=style&index=0&id=0c4af564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4af564",
  null
  
)

export default component.exports